import { apiProductsExport } from './apiProductsExport'
import { apiPurchaseOrder } from './apiPurchaseOrder'
import { apiOrders } from './apiOrders'
import { apiDelivery } from './apiDelivery'

const apiPurchase = {
	...apiProductsExport,
	...apiPurchaseOrder,
	...apiOrders,
	...apiDelivery,
}

export { apiPurchase }
